/* TLRacing product page: add to cart with add-ons, variant picker, sticky bar */
(() => {
  'use strict';
  const T = window.TLR || {};
  const R = T.routes || {};
  const lang = document.documentElement.lang || 'en-US';
  const money = (cents) => {
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: T.currency || 'USD' }).format((cents || 0) / 100); }
    catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const store = {
    get(k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } },
    set(k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} },
    del(k, s) { try { (s ? sessionStorage : localStorage).removeItem(k); } catch (e) {} }
  };
  const icon = {
    trash: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 15h10l1-15M10 10v7M14 10v7"/></svg>'
  };

  /* ---------------- Cart API ---------------- */
  const cartUrl = (R.cart || '/cart');
  async function getCart() {
    const r = await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('cart');
    return r.json();
  }
  async function addItems(items) {
    const r = await fetch((R.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || 'Could not add this item.');
    return data;
  }
  async function changeLine(key, quantity) {
    const r = await fetch((R.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || 'Could not update the cart.');
    return data;
  }
  const setCount = (n) => document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n; });

  function openCart() {
    const panel = document.querySelector('[data-panel="cart"]');
    const toggle = document.querySelector('[data-open="cart"]');
    if (panel && panel.classList.contains('is-open')) { toggle && toggle.click(); setTimeout(() => toggle && toggle.click(), 50); return; }
    if (toggle) toggle.click(); else window.location.href = '/cart';
  }
  /* ---------------- Product form ---------------- */
  function showFormError(form, msg) {
    const box = form.querySelector('[data-form-error]');
    if (box) { box.textContent = msg; box.hidden = !msg; }
  }
  document.querySelectorAll('form.tlr-product-form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const idInput = form.querySelector('[name="id"]');
      const id = Number(idInput && idInput.value);
      const btn = form.querySelector('[data-add-button]');
      if (!id) { showFormError(form, 'Please choose an option first.'); return; }
      const qty = Math.max(1, parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1);
      const items = [{ id, quantity: qty }];
      form.querySelectorAll('[data-addon-variant]:checked').forEach((cb) => items.push({ id: Number(cb.dataset.addonVariant), quantity: 1 }));
      showFormError(form, '');
      const label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
      try {
        await addItems(items);
        openCart();
      } catch (err) {
        showFormError(form, err.message);
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      }
    });
  });

  /* ---------------- Variant picker ---------------- */
  document.querySelectorAll('[data-option-picker]').forEach((picker) => {
    let variants = [];
    try { variants = JSON.parse(picker.dataset.variants); } catch (e) {}
    const groups = [...picker.querySelectorAll('[data-option-index]')];
    const hidden = picker.querySelector('[data-selected-variant]');
    const form = picker.closest('form');
    const section = picker.closest('[data-product-section]') || document;
    const choices = () => groups.map((g) => (g.querySelector('input:checked') || {}).value);

    function markAvailability(current) {
      groups.forEach((g, gi) => {
        g.querySelectorAll('.tlr-variant-pill').forEach((pill) => {
          const val = pill.querySelector('input').value;
          /* Available if some in-stock variant has this value plus the choices made in the groups before it */
          const ok = variants.some((v) => v.available && v.options[gi] === val && v.options.every((o, oi) => oi >= gi || o === current[oi]));
          pill.classList.toggle('is-unavailable', !ok);
          pill.classList.toggle('is-selected', pill.querySelector('input').checked);
        });
      });
    }

    function sync(initial) {
      const current = choices();
      markAvailability(current);
      const v = variants.find((x) => x.options.every((o, i) => o === current[i]));
      if (hidden) hidden.value = v ? v.id : '';
      const add = form && form.querySelector('[data-add-button]');
      const sticky = document.querySelector('[data-sticky-add]');
      const label = !v ? 'UNAVAILABLE' : (v.available ? 'ADD TO CART →' : 'SOLD OUT');
      if (add) { add.disabled = !v || !v.available; add.textContent = label; }
      if (sticky) { sticky.disabled = !v || !v.available; sticky.textContent = label.replace(' →', ''); }
      if (!v) return;
      document.querySelectorAll('[data-variant-price],[data-sticky-price]').forEach((el) => { el.textContent = money(v.price); });
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      const cmp = section.querySelector('[data-compare-price]');
      const save = section.querySelector('[data-save-badge]');
      if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = money(v.compare_at_price); }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'SAVE ' + money(v.compare_at_price - v.price); }
      const stock = section.querySelector('[data-stock-label]');
      if (stock) {
        stock.textContent = v.available ? `● IN STOCK · ${(T.shippingMessage || '').toUpperCase()}` : 'SOLD OUT';
        stock.classList.toggle('is-out', !v.available);
      }
      const gallery = document.querySelector('[data-product-gallery]');
      const target = (v.featured_image && v.featured_image.id) || (v.featured_media && v.featured_media.id);
      if (gallery && target) {
        const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
        const match = slides.findIndex((s) => String(s.dataset.imageId) === String(target));
        if (match >= 0) {
          const thumb = gallery.querySelector(`[data-gallery-thumb="${match}"]`);
          if (thumb) thumb.click();
          else slides.forEach((s, j) => s.classList.toggle('is-active', j === match));
        }
      }
      if (!initial) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url);
      }
    }
    picker.addEventListener('change', () => sync(false));
    sync(true);
  });

  /* ---------------- Sticky add to cart (mobile) ---------------- */
  const sticky = document.querySelector('[data-sticky-buy]');
  const mainBtn = document.querySelector('.tlr-product-form [data-add-button]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      const b = sticky.querySelector('button'); if (b) b.tabIndex = show ? 0 : -1;
    });
    io.observe(mainBtn);
    sticky.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
      const form = mainBtn.closest('form');
      if (form && !mainBtn.disabled) {
        if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
      }
    });
  }

})();
